/* eslint-disable no-unused-vars */
import React, { useEffect } from 'react';

const MenuIcon = ({ isMenuOpen, handleMenuClick }) => {
  useEffect(() => {
    const menuButton = document.querySelector('.menuIconButton');

    if (isMenuOpen) {
      // menuButton.classList.add('opened');
      // menuButton.setAttribute('aria-expanded',  menuButton.classList.contains('opened'));
    } else {
      // menuButton.classList.remove('opened');
    }
  }, [isMenuOpen]);

  return (
    <button className='menuIconButton' onClick={handleMenuClick} aria-label='Main Menu'>
      {/* <svg viewBox="0 0 100 100">
        <path
          className="line line1"
          d="M 20,29.000046 H 80.000231 C 80.000231,29.000046 94.498839,28.817352 94.532987,66.711331 94.543142,77.980673 90.966081,81.670246 85.259173,81.668997 79.552261,81.667751 75.000211,74.999942 75.000211,74.999942 L 25.000021,25.000058"
        />
        <path className="line line2" d="M 20,50 H 80" />
        <path
          className="line line3"
          d="M 20,70.999954 H 80.000231 C 80.000231,70.999954 94.498839,71.182648 94.532987,33.288669 94.543142,22.019327 90.966081,18.329754 85.259173,18.331003 79.552261,18.332249 75.000211,25.000058 75.000211,25.000058 L 25.000021,74.999942"
        />
      </svg> */}

      <svg
        className={`ham hamRotate ham1 ${isMenuOpen && 'active'}`}
        viewBox='0 0 100 100'
        width='100'
        xmlns='http://www.w3.org/2000/svg'
        version='1.1'
      >
        <path
          className='line top'
          d='m 30,33 h 40 c 0,0 9.044436,-0.654587 9.044436,-8.508902 0,-7.854315 -8.024349,-11.958003 -14.89975,-10.85914 -6.875401,1.098863 -13.637059,4.171617 -13.637059,16.368042 v 40'
        />
        <path className='line middle' d='m 30,50 h 40' />
        <path
          className='line bottom'
          d='m 30,67 h 40 c 12.796276,0 15.357889,-11.717785 15.357889,-26.851538 0,-15.133752 -4.786586,-27.274118 -16.667516,-27.274118 -11.88093,0 -18.499247,6.994427 -18.435284,17.125656 l 0.252538,40'
        />
      </svg>
    </button>
  );
};

export default MenuIcon;
